import { http } from '@/common/utils/HttpServices';
import { Routes } from '@/api/Routes';
import { FactureFournisseurStatsDTO } from '@/models/FactureFournisseurStatsDTO';

class StatsFactureService {
    public async getStatsFacturesFournisseur(): Promise<FactureFournisseurStatsDTO>{
        return http.get(Routes.FactureFournisseurRoutes.RecupererStatsFacturesFournisseur());
    }
}

export default new StatsFactureService();
